import React, { useMemo } from 'react';

import styled from 'styled-components';

import { RowRenderer, ColumnProps } from './DataTable.decl';
import { TableCell } from './TableCell';

export const RowWrapper = styled.tr`
  height: ${({ theme }) => `${theme.space.xl}px`};
  transition: all 0.25s ease-in-out;

  &:hover {
    background-color: ${({ theme }) => theme.colors.grey.lighter};
  }
`;

export interface TableRowProps<T> {
  /**
   * Columns structure of the table.
   * Please make sure the columns are properly memoized.
   */
  columns: ColumnProps<T>[];

  /** Data of the row */
  datum: T;

  /** Index of the row */
  rowIndex: number;

  /** Custom way to render the row; useful when we want to handle interactions with the rows */
  rowRenderer?: RowRenderer<T>;
}

export function TableRow<T>({ columns, datum, rowIndex, rowRenderer: Row }: TableRowProps<T>) {
  return useMemo(() => {
    if (Row) {
      return <Row datum={datum} rowIndex={rowIndex} columns={columns} />;
    }

    return (
      <RowWrapper>
        {columns.map(({ cellRenderer, width }, columnIndex) => (
          // eslint-disable-next-line react/no-array-index-key
          <TableCell key={`${rowIndex}-${columnIndex}`} width={width}>
            {cellRenderer({ datum, rowIndex, columnIndex })}
          </TableCell>
        ))}
      </RowWrapper>
    );
  }, [columns, datum, rowIndex, Row]);
}
